var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_30_322",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_30_322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.3093 0H-7.30933V24H31.3093V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3096 22.0457H-7.30908V24H31.3096V22.0457Z",
    fill: "#F32403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3096 17.9805H-7.30908V19.9348H31.3096V17.9805Z",
    fill: "#F32403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3096 14.2281H-7.30908V16.1825H31.3096V14.2281Z",
    fill: "#F32403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3096 10.7103H-7.30908V12.6645H31.3096V10.7103Z",
    fill: "#F32403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3096 6.95776H-7.30908V8.9119H31.3096V6.95776Z",
    fill: "#F32403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3096 3.28345H-7.30908V5.23771H31.3096V3.28345Z",
    fill: "#F32403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3093 0H-7.30933V1.9544H31.3093V0Z",
    fill: "#F32403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.42041 0H-7.30933V12.6645H9.42041V0Z",
    fill: "#011173"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.308902 0.797241L-0.137569 1.14511L0.246564 1.20084L-0.0311683 1.47151L0.0341646 1.85377L-0.308902 1.67324L-0.652635 1.85377L-0.586768 1.47151L-0.864502 1.20084L-0.480635 1.14511L-0.308902 0.797241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.42094 0.797241L2.59241 1.14511L2.97655 1.20084L2.69868 1.47151L2.76414 1.85377L2.42094 1.67324L2.07774 1.85377L2.14321 1.47151L1.86548 1.20084L2.24908 1.14511L2.42094 0.797241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.15081 0.797241L5.32215 1.14511L5.70628 1.20084L5.42855 1.47151L5.49402 1.85377L5.15081 1.67324L4.80748 1.85377L4.87295 1.47151L4.59521 1.20084L4.97895 1.14511L5.15081 0.797241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.88055 0.797241L8.05242 1.14511L8.43602 1.20084L8.15828 1.47151L8.22375 1.85377L7.88055 1.67324L7.53735 1.85377L7.60282 1.47151L7.32495 1.20084L7.70882 1.14511L7.88055 0.797241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.17718 2.04926L1.34851 2.39699L1.73252 2.45272L1.45478 2.72352L1.52025 3.10566L1.17718 2.92526L0.833448 3.10566L0.899315 2.72352L0.621582 2.45272L1.00531 2.39699L1.17718 2.04926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.90703 2.04926L4.07836 2.39699L4.4625 2.45272L4.18476 2.72352L4.25023 3.10566L3.90703 2.92526L3.56343 3.10566L3.6293 2.72352L3.35156 2.45272L3.73516 2.39699L3.90703 2.04926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.63677 2.04926L6.8081 2.39699L7.19236 2.45272L6.91463 2.72352L6.9801 3.10566L6.63677 2.92526L6.29357 3.10566L6.35903 2.72352L6.0813 2.45272L6.46503 2.39699L6.63677 2.04926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.17718 4.55219L1.34851 4.90005L1.73252 4.95578L1.45478 5.22658L1.52025 5.60885L1.17718 5.42832L0.833448 5.60885L0.899315 5.22658L0.621582 4.95578L1.00531 4.90005L1.17718 4.55219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.90703 4.55219L4.07836 4.90005L4.4625 4.95578L4.18476 5.22658L4.25023 5.60885L3.90703 5.42832L3.56343 5.60885L3.6293 5.22658L3.35156 4.95578L3.73516 4.90005L3.90703 4.55219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.63677 4.55219L6.8081 4.90005L7.19236 4.95578L6.91463 5.22658L6.9801 5.60885L6.63677 5.42832L6.29357 5.60885L6.35903 5.22658L6.0813 4.95578L6.46503 4.90005L6.63677 4.55219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.17718 7.05573L1.34851 7.40333L1.73252 7.45933L1.45478 7.73013L1.52025 8.11226L1.17718 7.93186L0.833448 8.11226L0.899315 7.73013L0.621582 7.45933L1.00531 7.40333L1.17718 7.05573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.90703 7.05573L4.07836 7.40333L4.4625 7.45933L4.18476 7.73013L4.25023 8.11226L3.90703 7.93186L3.56343 8.11226L3.6293 7.73013L3.35156 7.45933L3.73516 7.40333L3.90703 7.05573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.63677 7.05573L6.8081 7.40333L7.19236 7.45933L6.91463 7.73013L6.9801 8.11226L6.63677 7.93186L6.29357 8.11226L6.35903 7.73013L6.0813 7.45933L6.46503 7.40333L6.63677 7.05573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.17718 9.55902L1.34851 9.90689L1.73252 9.96262L1.45478 10.2332L1.52025 10.6157L1.17718 10.4349L0.833448 10.6157L0.899315 10.2332L0.621582 9.96262L1.00531 9.90689L1.17718 9.55902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.90703 9.55902L4.07836 9.90689L4.4625 9.96262L4.18476 10.2332L4.25023 10.6157L3.90703 10.4349L3.56343 10.6157L3.6293 10.2332L3.35156 9.96262L3.73516 9.90689L3.90703 9.55902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.63677 9.55902L6.8081 9.90689L7.19236 9.96262L6.91463 10.2332L6.9801 10.6157L6.63677 10.4349L6.29357 10.6157L6.35903 10.2332L6.0813 9.96262L6.46503 9.90689L6.63677 9.55902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.308658 3.30048L-0.137325 3.64834L0.246809 3.70394L-0.0309241 3.97474L0.0344087 4.35701L-0.308658 4.17648L-0.652391 4.35701L-0.586524 3.97474L-0.864258 3.70394L-0.480391 3.64834L-0.308658 3.30048Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.42119 3.30048L2.59266 3.64834L2.97679 3.70394L2.69892 3.97474L2.76439 4.35701L2.42119 4.17648L2.07799 4.35701L2.14346 3.97474L1.86572 3.70394L2.24932 3.64834L2.42119 3.30048Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.15106 3.30048L5.32239 3.64834L5.70653 3.70394L5.42879 3.97474L5.49426 4.35701L5.15106 4.17648L4.80773 4.35701L4.87319 3.97474L4.59546 3.70394L4.97919 3.64834L5.15106 3.30048Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.88079 3.30048L8.05266 3.64834L8.43626 3.70394L8.15853 3.97474L8.22399 4.35701L7.88079 4.17648L7.53759 4.35701L7.60306 3.97474L7.3252 3.70394L7.70906 3.64834L7.88079 3.30048Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.308658 5.80402L-0.137325 6.15175L0.246809 6.20748L-0.0309241 6.47828L0.0344087 6.86055L-0.308658 6.68002L-0.652391 6.86055L-0.586524 6.47828L-0.864258 6.20748L-0.480391 6.15175L-0.308658 5.80402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.42119 5.80402L2.59266 6.15175L2.97679 6.20748L2.69892 6.47828L2.76439 6.86055L2.42119 6.68002L2.07799 6.86055L2.14346 6.47828L1.86572 6.20748L2.24932 6.15175L2.42119 5.80402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.15106 5.80402L5.32239 6.15175L5.70653 6.20748L5.42879 6.47828L5.49426 6.86055L5.15106 6.68002L4.80773 6.86055L4.87319 6.47828L4.59546 6.20748L4.97919 6.15175L5.15106 5.80402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.88079 5.80402L8.05266 6.15175L8.43626 6.20748L8.15853 6.47828L8.22399 6.86055L7.88079 6.68002L7.53759 6.86055L7.60306 6.47828L7.3252 6.20748L7.70906 6.15175L7.88079 5.80402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.308658 8.30756L-0.137325 8.65516L0.246809 8.71116L-0.0309241 8.98169L0.0344087 9.36396L-0.308658 9.18342L-0.652391 9.36396L-0.586524 8.98169L-0.864258 8.71116L-0.480391 8.65516L-0.308658 8.30756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.42119 8.30756L2.59266 8.65516L2.97679 8.71116L2.69892 8.98169L2.76439 9.36396L2.42119 9.18342L2.07799 9.36396L2.14346 8.98169L1.86572 8.71116L2.24932 8.65516L2.42119 8.30756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.15106 8.30756L5.32239 8.65516L5.70653 8.71116L5.42879 8.98169L5.49426 9.36396L5.15106 9.18342L4.80773 9.36396L4.87319 8.98169L4.59546 8.71116L4.97919 8.65516L5.15106 8.30756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.88079 8.30756L8.05266 8.65516L8.43626 8.71116L8.15853 8.98169L8.22399 9.36396L7.88079 9.18342L7.53759 9.36396L7.60306 8.98169L7.3252 8.71116L7.70906 8.65516L7.88079 8.30756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.308658 10.8107L-0.137325 11.1586L0.246809 11.2142L-0.0309241 11.4853L0.0344087 11.8673L-0.308658 11.687L-0.652391 11.8673L-0.586524 11.4853L-0.864258 11.2142L-0.480391 11.1586L-0.308658 10.8107Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.42119 10.8107L2.59266 11.1586L2.97679 11.2142L2.69892 11.4853L2.76439 11.8673L2.42119 11.687L2.07799 11.8673L2.14346 11.4853L1.86572 11.2142L2.24932 11.1586L2.42119 10.8107Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.15106 10.8107L5.32239 11.1586L5.70653 11.2142L5.42879 11.4853L5.49426 11.8673L5.15106 11.687L4.80773 11.8673L4.87319 11.4853L4.59546 11.2142L4.97919 11.1586L5.15106 10.8107Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.88079 10.8107L8.05266 11.1586L8.43626 11.2142L8.15853 11.4853L8.22399 11.8673L7.88079 11.687L7.53759 11.8673L7.60306 11.4853L7.3252 11.2142L7.70906 11.1586L7.88079 10.8107Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/us.14f51f82e00e0fff1363a2bc5c2fa088.svg";
export { ForwardRef as ReactComponent };